<div class="content" role="main">
  <div>
    <router-outlet></router-outlet>
  </div>
</div>